import { render, staticRenderFns } from "./storeSetOrderGoods.vue?vue&type=template&id=21b705df&scoped=true&"
import script from "./storeSetOrderGoods.vue?vue&type=script&lang=js&"
export * from "./storeSetOrderGoods.vue?vue&type=script&lang=js&"
import style0 from "./storeSetOrderGoods.vue?vue&type=style&index=0&id=21b705df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b705df",
  null
  
)

component.options.__file = "storeSetOrderGoods.vue"
export default component.exports